<template>  
  <v-container fluid grid-list-lg class="ma-0 pa-0">
    <v-layout row>
      <template v-for="(item,i) in items">
        <v-flex xs12 md4 :key="i">
          <v-card
            class="mx-auto"          
            outlined
          >
            <v-list-item three-line>
              <v-list-item-content>
                <div class="overline mb-4">Survey</div>
                <v-list-item-title class="headline mb-1">{{ ((1-1)*20)+(items.findIndex(x=>x==item)+1) }}. {{item.name}}</v-list-item-title>
                <v-list-item-subtitle>{{item.description}}</v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-avatar
                tile
                size="80"
                :color="item.color=='#fff'?'#000':item.color"
              ><v-icon large class="white--text">assignment</v-icon></v-list-item-avatar>
            </v-list-item>
            
            <v-card-text>
              <v-chip :color="item.color" :to="{name:'report/responden',query:{id:item.id}}" dark><v-icon left>person</v-icon> responden : {{item.counting.all | currency}}</v-chip>
            </v-card-text>
            
            <v-divider class="mx-4"></v-divider>

            <v-card-title>Presentation availability</v-card-title>

            <v-card-text class="pt-0">
              <template v-for="(widget, i) in widgets">
                <v-btn :key="i" class="mr-2 mt-2" small :color="widget.color" dark label @click="openDialog(item, widget)">{{widget.name}}</v-btn>              
              </template>              
            </v-card-text>
            <v-dialog v-model="item.dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
              <v-card>
                <v-app-bar dense dark :color="item.color=='#fff'?'#000':item.color" fixed>
                  <v-btn icon dark @click="item.dialog = false">
                    <v-icon>arrow_back</v-icon>
                  </v-btn>
                  <v-toolbar-title>{{item.name}}</v-toolbar-title>
                  <v-chip v-if="option.widget" class="ml-2" :color="option.widget.color" dark>{{option.widget.name}}</v-chip>
                  <v-spacer></v-spacer>
                  <v-menu bottom right offset-y>
                    <template v-slot:activator="{ on }">
                      <v-btn dark icon v-on="on">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <template v-for="(widget, i) in widgets">
                        <v-list-item :key="i" @click="option.widget = widget">
                          <v-list-item-title>{{widget.name}}</v-list-item-title>                        
                        </v-list-item>
                      </template>                      
                    </v-list>
                  </v-menu>
                </v-app-bar>
                <div style="padding-top:48px">
                  <template v-if="option.widget">
                    <widget-sebaran v-if="option.widget.id === 1" :jilid="item" />
                    <!--<widget-demografi v-if="option.widget.id === 2"  :jilid="item" />-->
                    <widget-efektifitas v-if="option.widget.id === 3"  :jilid="item" />
                    <widget-persilangan v-if="option.widget.id === 4"  :jilid="item" />
                  </template>
                </div>  
              </v-card>  
            </v-dialog>  
          </v-card>
        </v-flex>
      </template>
      <template v-if="loading">
        <v-flex xs12 md4 v-for="(i) in 12" :key="i">
          <v-skeleton-loader        
            style="width:100%"            
            type="card"
          ></v-skeleton-loader>
        </v-flex>
      </template>
    </v-layout>
    <v-layout>
      <v-flex xs12>
        <v-btn color="blue" v-if="page<totalPages" :loading="loading" dark @click="page = page + 1">Load More</v-btn>        
      </v-flex>
    </v-layout>    
  </v-container>  
</template>

<script>
import { debounce } from 'lodash'
import model from '@/app/models/Survey'

import WidgetSebaran     from './widget/sebaran'
import WidgetDemografi   from './widget/demografi'
import WidgetEfektifitas from './widget/efektifitas'
import WidgetPersilangan from './widget/persilangan'

export default {
  components:{WidgetSebaran, WidgetDemografi, WidgetEfektifitas, WidgetPersilangan},
  data () {
    return {
      term : null,      
      items: [],     
      pagination:{sortBy:[]},
      page : 1,      
      totalPages: 0,      
      loading: false, 
      widgets: [
        {id:1, name:'sebaran', color:'cyan'},
        //{id:2, name:'demografi', color:'teal'},
        {id:3, name:'efektifitas', color:'pink'},
        {id:4, name:'persilangan', color:'purple'},
      ],
      option:{
        widget:{},        
      }     
    }
  },
  computed:{
    status(){
      return this.$store.getters.DICTIONS.JilidStatus;      
    },    
  },
  watch:{
    page(newPage){
      this.readItems(newPage) 
    },
    pagination:{
      handler(){
        this.readItems(this.page) 
      }, deep:true      
    }
  },  
  created () {
    this.readItems()
  },
  methods: {
    openDialog(item, widget){
      item.dialog = true;
      this.option.widget = widget;
    },

    search: debounce(function (term) {
      this.term = term;
      this.readItems()
    }, 800),

    readItems (page = 0) {
      this.loading = true
      
      let  sortby = this.pagination.sortBy[0] ? this.pagination.sortDesc[0] ? 
        '-'+this.pagination.sortBy[0] : this.pagination.sortBy[0] : 'id';                          
      
      const params = {
        perPage: 20,
        page: page,
        q: this.term,        
        //sort:sortby,
        expand:'node,counting,quetionnaires'
      }

      model.jilids(params)
        .then(response => {
          if(Array.isArray(response.data)){
            response.data.forEach(item=>{item.dialog=false});
          }
          this.items = [...this.items, ...response.data];
          this.totalPages = response.pagination.pageCount;               
          this.loading = false
        })
    },    
  },  
}
</script>